import { Platform } from "./models";
import { getPlatformType } from "./utils";

export const AFFILIATE_PARAM_DEFAULTS_MID: Record<Platform, string> = {
  [Platform.PlayId]: '368983_2128236',
  [Platform.FunId]: '368983_2128236',
  [Platform.BoomId]: '374847_2167775',
  [Platform.OnePass]: '374847_2167775',
  [Platform.Default]: '368983_2128236',
} as const;


/** Appends configured default `mid` to outbound URLs (see {@link AFFILIATE_PARAM_DEFAULTS_MID}). */
export function appendMarketingParamsToUrl(urlString: string): string {
  const currentUrl = new URL(window.location.href);
  const urlMid = currentUrl.searchParams.get("mid");
  const urlFluid = currentUrl.searchParams.get("fluid");
  const defaultMid = AFFILIATE_PARAM_DEFAULTS_MID[getPlatformType() as Platform];

  try {
    const url = new URL(urlString, window.location.href);
    url.searchParams.set("mid", urlMid || defaultMid);

    if (urlFluid) {
      url.searchParams.set("fluid", urlFluid);
    }

    return url.toString();
  } catch {
    return urlString;
  }
}